import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ScreenSize } from 'libs/portal/src/layout/layout.service';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { TitleService } from 'libs/portal/src/services/title/title.service';
import { Endpoints } from '@huge-monorepo/portal/config';
import { UserAccessRole, UserRightsService } from 'libs/portal/src/services/user-rights/user-rights.service';
import { DomainRoles, Domains } from 'libs/portal/src/models/DomainInfo';
import { MatTabGroup } from '@angular/material/tabs';
export interface ReportType {
  ID: number;
  Name: string;
  Description: string;
  Details: string;
}
@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
})
export class ReportsComponent implements OnInit {
  @ViewChild('tab') tab: MatTabGroup;

  ScreenSize = ScreenSize;
  isLoaded = false;
  reportsIndex = 0;

  reports: ReportType[][] = [];
  reportNames: string[] = [];

  private kaTypes: string[] = [];

  AccessObject: UserAccessRole | null;

  constructor(
    private genericService: GenericService,
    private router: Router,
    private endpoints: Endpoints,
    private titleService: TitleService,
    private auth: UserRightsService,
    private domainRoles: DomainRoles,
    private domains: Domains,
  ) { }

  ngOnInit() {
    this.kaTypes = this.auth.GetKeepAliveTypes();
    this.AccessObject = this.auth.GetUserAccessRoles();
    this.titleService.pageTitle = 'Reports';
    if (this.AccessObject) {
      this.getReportTypes();
    }
  }

  rowSelected(ID: number): void {
    this.router.navigate([`/Reports/${ID}`]);
  }

  getReportTypes() {

    this.genericService.GET(this.endpoints.GET_REPORT_TYPES, true).subscribe((resp: Object) => {
      let x = 0;
      if (resp['body'] != null && resp['body'].length > 0) {
        const reports = resp['body'];
        if (this.auth.HasCDRAccess() && this.AccessObject.IsCDRReporting()) {
          this.reports[x] = reports.filter((report) => {
            //TODO: Add this back in when complete
            return report.AccessDomainID == 11 && report.ID != 4;
          });
          x++;
          this.reportNames.push('Data Reports');
        }

        if (this.auth.HasKeepAliveAccess() && this.AccessObject.IsKeepAliveReporting()) {
          this.reports[x] = reports.filter((report) => {
            if (this.kaTypes.includes('tls') && !this.kaTypes.includes('location')) {
              return report.AccessDomainID == 12 && report.Name.includes('TLS');
            } else if (this.kaTypes.includes('location') && !this.kaTypes.includes('tls')) {
              return report.AccessDomainID == 12 && !report.Name.includes('TLS');
            } else {
              return report.AccessDomainID == 12;
            }
          });
          x++;
          this.reportNames.push('Keep Alive Reports');
        }

        if (this.auth.HasMikrotikAccess() && this.AccessObject.IsMikrotikReporting()) {
          // this.MikrotikReports = reports.filter((report) => {
          //   return report.AccessDomainID == 13;
          // });
          // this.MikrotikReports = [];
          x++;
          this.reportNames.push('Mikrotik Reports');
        }

        if (this.auth.HasRelayAccess() && this.AccessObject.IsRelayReporting()) {
          this.reports[x] = reports.filter((report) => {
            return report.AccessDomainID == 14;
          });
          x++;
          this.reportNames.push('Relay Reports');
        }
        this.reports.forEach((elem) => elem.sort((a, b) => (a.Name > b.Name ? 1 : b.Name > a.Name ? -1 : 0)));
      }

      this.isLoaded = true;
    });
  }
}
